import { approvedProductionCalendars } from './generated'

export type ApprovedProductionCalendar = (typeof approvedProductionCalendars)[number]
export type ProductionCalendarDay = ApprovedProductionCalendar['days'][number]

export interface ProductionCalendarMonth {
  month: number
  days: readonly (ProductionCalendarDay | null)[]
  workingDays: number
  nonWorkingDays: number
}

export function buildProductionCalendarMonths(
  calendar: ApprovedProductionCalendar,
): readonly ProductionCalendarMonth[] {
  return calendar.aggregates.months.map((aggregate) => {
    const days = calendar.days.filter((day) => Number(day.date.slice(5, 7)) === aggregate.month)
    const firstWeekday = new Date(`${days[0]?.date ?? ''}T00:00:00Z`).getUTCDay()
    const mondayFirstOffset = (firstWeekday + 6) % 7
    const trailingCells = (7 - ((mondayFirstOffset + days.length) % 7)) % 7

    return {
      month: aggregate.month,
      days: [
        ...Array.from<null>({ length: mondayFirstOffset }).fill(null),
        ...days,
        ...Array.from<null>({ length: trailingCells }).fill(null),
      ],
      workingDays: aggregate.workingDays,
      nonWorkingDays: aggregate.nonWorkingDays,
    }
  })
}

export function productionCalendarYearRoute(year: number): string {
  return `/proizvodstvennyj-kalendar-${year}`
}
